import { render, staticRenderFns } from "./UserCardSettings.vue?vue&type=template&id=9dde2b00&scoped=true&"
import script from "./UserCardSettings.vue?vue&type=script&lang=ts&"
export * from "./UserCardSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dde2b00",
  null
  
)

export default component.exports